import { createAsyncThunk } from '@reduxjs/toolkit'
import { APIError, get } from '../services/crud'
import { ServiceConfig } from '../services/config'
import { GetLocationNotesInput, GetLocationNotesResponse } from './typings'
import { toQueryString } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}/Location/core`

export const getLocationNotes = createAsyncThunk<
  GetLocationNotesResponse,
  GetLocationNotesInput,
  { rejectValue: APIError }
>('locationNotes/get', async (model, thunkApi) => {
  const { id, skip, take } = model

  const response = await get(
    `${baseUrl}/${id}/notes?${toQueryString({ skip, take })}`,
  )

  if (response.ok) {
    const payload: GetLocationNotesResponse = await response.json()

    if (!!payload.items) {
      payload.items.forEach((note) => {
        note.noteDate = new Date(note.noteDate)
      })
    }

    payload.locationId = id

    return payload
  }
  return thunkApi.rejectWithValue((await response.json()) as APIError)
})
